import { LI, Spacer, Text, UL } from '@vapor/ui';
import React from 'react';
import { Content } from '../components/boxes/content';
import { MarketingLayout } from '../layout/marketing';

export default function Privacy() {
  return (
    <MarketingLayout>
      <Content style={{ maxWidth: 800 }}>
        <Text as="h1" size={40} weight={600}>
          Privacy Policy
        </Text>

        <Spacer height={20} />

        <p>
          Please read these terms carefully before you use the Weekrise Service located at
          https://{typeof window == 'undefined' ? 'weekrise.com' : window.location.hostname}{' '}
          ("Weekrise", "we", "us", "our", "the service").
          <br />
          <br />
          Your privacy is very important. That's why we take care of your data.
          <br />
          <br />
          The service is build using the most up-to-date security measures.
          <br />
          <br />
          <h2>External data Processors:</h2>
          <br />
          The service is hosted at <a href="https://vercel.com">Vercel</a>,{' '}
          <a href="https://cloduflare.com">Cloudflare</a> and{' '}
          <a href="https://namecheap.com">Namecheap</a>.
          <UL>
            <LI>
              Vercel: We use Vercel to host the Fronted application as well as some backend
              code that gets executed when you use Weekrise. You can learn more about Vercel in
              their <a href="https://vercel.com/legal/privacy-policy">Privacy Policy</a>.
            </LI>

            <LI>
              Cloudflare: We use Cloudflare to host the Fronted application and some parts of
              the backend. Cloudflare also provides us with infrastructure to handle attacks
              and load-spikes. You can learn more about Cloudflare in their{' '}
              <a href="https://www.cloudflare.com/privacypolicy/">Privacy Policy</a>.
            </LI>

            <LI>
              Namecheap: We use namecheap to manage this domain and to host data provided by
              you (eg. when you sign up or manage tasks). You can learn more in Namecheap's{' '}
              <a href="https://www.namecheap.com/legal/general/privacy-policy/">
                Privacy Policy
              </a>
              .
            </LI>
          </UL>
          <br />
          <h2>Analytics:</h2>
          <br />
          We use <a href="https://www.cloudflare.com/">Cloudflare</a> for analytics data
          collection. This data is anonymized and non-identifiable. Cloudflare Analytics does
          not use any cookies.
          <br />
          <br />
          <h2>Cookies:</h2>
          <br />
          We don't set any tracking or fingerprinting cookies. The only cookies we set are
          necessary to operate the service.
          <UL>
            <LI>
              Authentication Session: When you log in or sign up, we store a token identifying
              you, this ensures that you remain logged in, even when you close the browser
              window.
            </LI>

            <LI>
              Settings: Some settings are stored on your Computer in Localstorage or IndexedDB.
              This ensures that settings you configured on the website are available when you
              return to the website.
            </LI>

            <LI>
              Synchronized Data: We use IndexedDB to store the current representation of the
              data in a calendar locally on your computer. This reduces load-times and makes
              the app available offline.
            </LI>
          </UL>
          <br />
          <h2>Contact:</h2>
          <br />
          If you want data to be deleted or corrected please contact tobias@herber.space
          <br />
          <br />
          If you have any questions about Weekrise or your privacy please contact
          tobias@herber.space
          <br />
          <br />
          Thanks for using our service!
        </p>
      </Content>
    </MarketingLayout>
  );
}
